module.exports = __webpack_public_path__ + "img/ai.2724a1cc.png";